import 'scss/solutions/glasses-AR-solution.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'



// WEBPACK FOOTER //
// ./src/js/entry/solutions/glasses-AR-solution.js